"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _UICardWrapper = _interopRequireDefault(require("UIComponents/card/UICardWrapper"));

var _UICardSection = _interopRequireDefault(require("UIComponents/card/UICardSection"));

var _Branding = _interopRequireDefault(require("MeetingsBase/models/Branding"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _color = require("MeetingsBase/utils/color");

var _default = (0, _createReactClass.default)({
  propTypes: {
    className: _propTypes.default.string,
    cardSectionClassName: _propTypes.default.string,
    children: _propTypes.default.node.isRequired,
    branding: _propTypes.default.instanceOf(_Branding.default).isRequired
  },
  getPrimaryColorToUse: function getPrimaryColorToUse() {
    var primaryColor = this.props.branding.primaryColor;
    return primaryColor;
  },
  getTextColorToUse: function getTextColorToUse() {
    var primaryColor = this.props.branding.primaryColor;
    return (0, _color.getTextColor)(primaryColor);
  },
  getStyle: function getStyle() {
    var primaryColorToUse = this.getPrimaryColorToUse();
    var textColorToUse = this.getTextColorToUse();
    return {
      backgroundColor: primaryColorToUse,
      backgroundImage: 'none',
      color: textColorToUse
    };
  },
  render: function render() {
    var _this$props = this.props,
        className = _this$props.className,
        cardSectionClassName = _this$props.cardSectionClassName,
        children = _this$props.children;
    return _react.default.createElement(_UICardWrapper.default, {
      className: className,
      style: this.getStyle()
    }, _react.default.createElement(_UICardSection.default, {
      className: cardSectionClassName
    }, _react.default.createElement(_UIFlex.default, {
      direction: "column",
      align: "center",
      justify: "start"
    }, children)));
  }
});

exports.default = _default;
module.exports = exports.default;